import { toRem, toRems } from 'helpers/theme'
/* eslint-disable quote-props */

const tabNumWidth = 30

const style = ({ theme, numTabs, tabWidth, tabOffset, activeTab }) => ({
    maxWidth: toRem(1120),
    margin: '55px auto 0',
    paddingBottom: toRem(20),

    [theme.breakpoints.up('md')]: {
        margin: '122px auto 0'
    },

    '& .show': {
        display: 'block'
    },

    '& .hide': {
        display: 'none'
    },

    '& .TabHeadlines': {
        display: 'flex',
        justifyContent: 'space-between',
        margin: '15px 0',

        '.Tab': {
            position: 'relative',
            textAlign: 'right',
            fontSize: toRem(20),
            color: theme.colors.blueDark,
            width: `calc(100% / ${numTabs - 1})`,

            '&:first-of-type': {
                width: toRem(tabNumWidth)
            },

            '&:last-child': {
                margin: 0
            },

            '&:hover': {
                '& .Number': {
                    background: theme.colors.blueLight,
                    color: `${theme.colors.blueDark} !important`
                }
            },
            [theme.breakpoints.up('lg')]: {
                width: 'auto',
                margin: '0 20px 0 0',
                '&:first-of-type': {
                    width: 'auto'
                }
            },

            '& .Number': {
                display: 'inline-block',
                width: toRem(tabNumWidth),
                height: toRem(30),
                lineHeight: toRem(26),
                border: `2px solid ${theme.colors.blueDark}`,
                fontSize: toRem(14),
                textAlign: 'center',
                borderRadius: '50%',

                '&::before': {
                    content: '""',
                    margin: 'auto',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    background: theme.colors.blueDark,
                    width: `calc(100% - ${toRem(30)})`,
                    height: toRem(2),
                    position: 'absolute',
                    top: 0,
                    right: toRem(30),
                    bottom: 0
                },

                [theme.breakpoints.up('lg')]: {
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    margin: 'auto',
                    '&::after': {
                        content: 'none'
                    }
                }
            },

            '& .Number:last-child': {
                '&::after': {
                    content: 'none'
                }
            },

            '& .Headline': {
                display: 'none',
                paddingLeft: toRem(40),
                textAlign: 'left',
                [theme.breakpoints.up('lg')]: {
                    display: 'inline-block'
                }
            },

            '&.TabSelected': {
                color: theme.colors.goldDark,

                '& .Number': {
                    color: theme.colors.blueMid,
                    border: `2px solid ${theme.colors.goldDark}`,
                    background: theme.colors.goldDark,

                    '&::before': {
                        background: theme.colors.goldDark
                    }
                }
            },

            '&.TabDone': {
                '& .Number': {
                    color: theme.colors.goldDark,
                    border: `2px solid ${theme.colors.goldDark}`,

                    [theme.breakpoints.up('lg')]: {
                        color: theme.colors.blueDark,
                        border: `2px solid ${theme.colors.blueDark}`
                    },

                    '&::before': {
                        background: theme.colors.goldDark
                    }
                }
            }
        }
    },
    [theme.breakpoints.up('lg')]: {
        '& .TabIndicatorWrap': {
            position: 'relative',
            display: 'inline-block',
            width: '100%',
            background: theme.colors.blueDark,
            height: toRem(4),
            borderRadius: 4,

            '& .TabIndicator': {
                position: 'absolute',
                height: '100%',
                display: 'inline-block',
                transition: 'all 1s',
                background: theme.colors.goldDark,
                width: tabWidth,
                left: tabOffset,
                borderRadius: 4
            }
        }
    },

    '& .TabPanel': {
        [theme.breakpoints.up('lg')]: {
            display: 'flex',
            alignItems: 'center',
            marginTop: toRem(35)
        },

        '& .Headline': {
            marginBottom: toRem(10),
            fontSize: toRem(14),
            color: theme.colors.goldDark,
            textAlign: 'left',
            [theme.breakpoints.up('md')]: {
                display: 'none'
            }
        },

        '& .Content': {
            marginBottom: toRem(20),
            paddingRight: toRem(50),
            fontSize: toRem(14),
            [theme.breakpoints.up('lg')]: {
                width: '40%',
                marginBottom: 0,
                fontSize: toRem(20)
            }
        },

        '& .Image': {
            height: 200,
            overflow: 'hidden',
            borderRadius: 4,
            display: 'flex',

            '& > div': {
                height: 'auto !important'
            },

            [theme.breakpoints.up('480')]: {
                height: 300
            },

            [theme.breakpoints.up('md')]: {
                height: 320
            },

            img: {
                alignSelf: 'center',
                minWidth: '100%',
                height: 'auto',
                borderRadius: 4
            },

            [theme.breakpoints.up('lg')]: {
                width: '60%'
            }
        }
    }
})

export default style
